import { Product } from '@/mocks/products';

interface ProductCardProps {
  product: Product;
  showCategory?: boolean;
}

export function ProductCard({ product }: ProductCardProps) {
  return (
    <a
      href={product.productUrl}
      target="_blank"
      rel="noopener nofollow"
      className="group relative flex flex-col bg-background-50 rounded-lg overflow-hidden border border-background-200/60 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative w-full aspect-[4/5] overflow-hidden bg-background-100">
        <img
          src={product.imageUrl}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
            const parent = (e.target as HTMLImageElement).parentElement;
            if (parent) {
              parent.innerHTML = '<div class="w-full h-full flex items-center justify-center text-foreground-400"><i class="ri-image-line text-4xl"></i></div>';
            }
          }}
        />
        <div className="absolute top-2 right-2 bg-background-50/90 backdrop-blur-sm text-foreground-900 text-xs font-semibold px-2 py-1 rounded-md border border-background-200/50">
          {product.priceYuan}
        </div>
      </div>
      <div className="p-3 flex flex-col flex-1">
        <h3 className="text-foreground-900 text-sm font-medium leading-tight line-clamp-2 min-h-[2.5rem] group-hover:text-primary-700 transition-colors duration-200">
          {product.name}
        </h3>
        <div className="mt-2 flex items-center justify-between">
          <span className="text-foreground-700 text-xs font-semibold">
            {product.priceUsd}
          </span>
          <span className="text-primary-700 text-xs font-semibold flex items-center gap-1">
            <span className="bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full text-xs">
              Buy Now
            </span>
            <i className="ri-arrow-right-up-line text-sm transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
          </span>
        </div>
      </div>
    </a>
  );
}

export default ProductCard;